import type { AnyAction } from 'redux';

export const connectionName = 'EMH-LOCAL-FOOTNOTE_STORE' as const;

export const ADD_FOOTNOTE = `${connectionName}.ADD_FOOTNOTE`;
export const ADD_FOOTNOTES = `${connectionName}.ADD_FOOTNOTES`;
export const REMOVE_FOOTNOTE = `${connectionName}.REMOVE_FOOTNOTE`;
export const REMOVE_FOOTNOTES = `${connectionName}.REMOVE_FOOTNOTES`;

type Action<T, P> = { type: T; payload: P };
export type AddFootnoteAction = Action<typeof ADD_FOOTNOTE, FootnoteActionPayload>;
export type AddFootnotesAction = Action<typeof ADD_FOOTNOTES, FootnotesActionPayload>;
export type RemoveFootnoteAction = Action<typeof REMOVE_FOOTNOTE, FootnoteActionPayload>;
export type RemoveFootnotesAction = Action<typeof REMOVE_FOOTNOTES, FootnotesActionPayload>;

export type Actions = AddFootnoteAction | AddFootnotesAction | RemoveFootnoteAction | RemoveFootnotesAction | AnyAction;

export interface FootnoteActionPayload {
  text: string;
  nonIndexed?: boolean;
  context?: string;
}

export interface FootnotesActionPayload {
  context?: string;
  footnotes: {
    text: string;
    nonIndexed?: boolean;
  }[];
}

export interface FootnoteItem {
  text: string;
  referenceNumber: number;
  referenceCounter: number;
}

export interface LocalFootnoteStoreState {
  contexts: Record<string, FootnoteItem[]>;
}

export type FootnoteStoreDispatchers = {
  addFootnote: (footnote: FootnoteActionPayload) => void;
  addFootnotes: (footnote: FootnotesActionPayload) => void;
  removeFootnote: (footnote: FootnoteActionPayload) => void;
  removeFootnotes: (footnote: FootnotesActionPayload) => void;
};
